import React from "react"
import PropTypes from "prop-types"
import "./button.scss"

const Button = ({ type, text, handleClick, className, children }) => {
  return (
    <button
      className={`button ${type} ${className}`}
      onClick={handleClick}
    >
      <p>
        {text}
      </p>
      {children}
    </button>
  )
}

Button.propTypes = {
  type: PropTypes.string,
  text: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  children: PropTypes.element
}

Button.defaultProps = {
  type: "",
  text: "",
  className: "",
  children: <></>
}
export default Button
